@if (this.fusionService.selectedMiroByTemplate && this.fusionService.selectedMiroByTemplate.metadata.templateId) {
  <div class="fusion-container">
    <!-- ===== INTRO ===== -->
    <div class="fusion-intro">
      <div class="fusion-logo-icon">
        <i class="ri-artboard-2-line"></i>
      </div>
      <div>
        <h5
          class="mb-0"
          i18n="@@miro-by-template"
        >Miro: Board von Template</h5>
        <small
          class="text-muted"
          i18n="@@miro-by-template-intro-description"
          >
          Verbinde ein Miro-Template-Board mit diesem Fusion-View.
        </small>
      </div>
    </div>
    <hr class="fusion-divider" />
    <!-- ===== TITEL + IDENTIFIKATOR ===== -->
    <section class="fusion-section">
      <h6
        class="fusion-section-title"
        i18n="@@title"
      >Titel</h6>
      <input
        pInputText
        type="text"
        [(ngModel)]="this.fusionService.selectedMiroByTemplate.metadata.title"
        [ngModelOptions]="{ updateOn: 'blur' }"
        (ngModelChange)="this.fusionService.updateFusionFieldFor(this.fusionService.selectedMiroByTemplate._id, 'title', this.fusionService.selectedMiroByTemplate.metadata.title)"
        class="w-100"
        >
      <small class="fusion-section-hint mt-1 d-block">
        <span i18n="@@fusion-view-name">Identifikator</span>: {{ this.fusionService.selectedMiroByTemplate.metadata.name
        }}
      </small>
    </section>
    <hr class="fusion-divider" />
    <div class="fusion-sections">
      <!-- ===== 1. TEMPLATE-URL + OPTIONEN ===== -->
      <section class="fusion-section">
        <h6
          class="fusion-section-title"
          i18n="@@fusion-view-template-url"
        >Template-URL</h6>
        <div class="video-url-row">
          @if (!this.idInvalid) {
            <div class="video-preview">
              <iframe [src]="this.iframeUrl"></iframe>
            </div>
          }
          <div class="video-url-controls">
            @if (this.idInvalid) {
              <div class="d-flex gap-2 align-items-start mb-3">
                <input
                  pInputText
                  pSize="small"
                  class="flex-fill"
                  [(ngModel)]="this.fusionService.selectedMiroByTemplate.metadata.templateId"
                  [ngModelOptions]="{updateOn: 'blur'}"
                  (ngModelChange)="this.boardUrlInputChange($event)"
                  placeholder="https://miro.com/app/board/..."
                  >
              </div>
            } @else {
              <div class="d-flex gap-2 align-items-start mb-3">
                <input
                  pInputText
                  pSize="small"
                  class="flex-fill"
                  [readonly]="true"
                  [value]="'https://miro.com/app/board/' + this.fusionService.selectedMiroByTemplate.metadata.templateId + '/'"
                  >
                <p-button
                  size="small"
                  severity="secondary"
                  icon="ri-close-line"
                  (onClick)="this.boardUrlInputChange('')"
                ></p-button>
              </div>
            }
            <!-- Board-Einstellungen -->
            <h6
              class="fusion-section-title mt-2"
              i18n="@@miro-board-settings"
            >Board-Einstellungen</h6>
            <div class="d-flex flex-column gap-3">
              <!-- Bearbeitbar -->
              <div class="display-option-toggle">
                <p-toggleswitch
                  [ngModel]="this.fusionService.selectedMiroByTemplate.metadata.editadble"
                  (ngModelChange)="this.fusionService.selectedMiroByTemplate.metadata.editadble = $event; this.fusionService.updateFusionField('editadble', $event); this.setIframeUrlFromSettings()"
                ></p-toggleswitch>
                <label
                  class="form-label fw-semibold mb-0"
                  i18n="@@fusion-view-miro-editable"
                >Bearbeitbar</label>
              </div>
              <!-- Autoplay -->
              <div class="display-option-toggle">
                <p-toggleswitch
                  [ngModel]="this.fusionService.selectedMiroByTemplate.metadata.autoplay"
                  (ngModelChange)="this.fusionService.selectedMiroByTemplate.metadata.autoplay = $event; this.fusionService.updateFusionField('autoplay', $event); this.setIframeUrlFromSettings()"
                ></p-toggleswitch>
                <label
                  class="form-label fw-semibold mb-0"
                  i18n="@@fusion-view-miro-autoplay"
                >Automatisch abspielen</label>
              </div>
            </div>
          </div>
        </div>
      </section>
      <hr class="fusion-divider" />
      <!-- ===== 2. DARSTELLUNGSOPTIONEN (INITIAL) + PREVIEW ===== -->
      <section class="fusion-section">
        <h6
          class="fusion-section-title"
          i18n="@@fusionconfig-display-options"
        >Darstellungsoptionen (Initial)</h6>
        <small
          class="fusion-section-hint"
          i18n="@@fusionconfig-display-options-hint"
          >
          Lege fest, wie der Bot und der Inhalt im Fusion-View dargestellt werden.
        </small>
        <div class="display-options-row">
          <div class="display-options-controls">
            <!-- Ansichtsmodus -->
            <div class="display-option-field">
              <p-select
                [options]="this.viewModeOptions"
                optionLabel="label"
                optionValue="value"
                [(ngModel)]="this.fusionService.selectedMiroByTemplate.metadata.viewMode"
                [ngModelOptions]="{updateOn: 'blur'}"
                (ngModelChange)="this.fusionService.updateFusionField('viewMode', this.fusionService.selectedMiroByTemplate.metadata.viewMode)"
              ></p-select>
            </div>
            <!-- Bot-Typ -->
            <div class="display-option-field">
              <p-selectbutton
                [options]="this.botTypeOptions"
                optionLabel="label"
                optionValue="value"
                [(ngModel)]="this.fusionService.selectedMiroByTemplate.metadata.bottype"
                (ngModelChange)="this.fusionService.updateFusionField('bottype',this.fusionService.selectedMiroByTemplate.metadata.bottype)"
                [unselectable]="true"
                >
                <ng-template
                  let-item
                  pTemplate="item"
                  >
                  <i
                    [class]="item.icon"
                    class="me-1"
                  ></i>
                  <span>{{ item.label }}</span>
                </ng-template>
              </p-selectbutton>
            </div>
            <!-- Bot anzeigen -->
            <div class="display-option-toggle">
              <p-toggleswitch
                [ngModel]="!this.fusionService.selectedMiroByTemplate.metadata.botHidden"
                (ngModelChange)="this.fusionService.selectedMiroByTemplate.metadata.botHidden = !$event; this.fusionService.updateFusionField('botHidden', this.fusionService.selectedMiroByTemplate.metadata.botHidden)"
              ></p-toggleswitch>
              <label
                class="form-label fw-semibold mb-0"
                i18n="@@fusionconfig-bot-visible"
              >Bot anzeigen</label>
            </div>
            <!-- Bot-Button anzeigen -->
            <div class="display-option-toggle">
              <p-toggleswitch
                [ngModel]="!this.fusionService.selectedMiroByTemplate.metadata.botButtonHidden"
                (ngModelChange)="this.fusionService.selectedMiroByTemplate.metadata.botButtonHidden = !$event; this.fusionService.updateFusionField('botButtonHidden', this.fusionService.selectedMiroByTemplate.metadata.botButtonHidden)"
              ></p-toggleswitch>
              <label
                class="form-label fw-semibold mb-0"
                i18n="@@fusionconfig-bot-button-visible"
              >Bot-Button anzeigen</label>
            </div>

            <!-- Disclaimer-Platzierung -->
            <div class="display-option-toggle">
              <p-toggleswitch
                [ngModel]="this.fusionService.selectedMiroByTemplate.metadata.disclaimerPlacement === 'fusionview'"
                (ngModelChange)="this.fusionService.selectedMiroByTemplate.metadata.disclaimerPlacement = $event ? 'fusionview' : 'botview'; this.fusionService.updateFusionField('disclaimerPlacement', this.fusionService.selectedMiroByTemplate.metadata.disclaimerPlacement)"
              ></p-toggleswitch>
              <label
                class="form-label fw-semibold mb-0"
                i18n="@@fusionconfig-disclaimer-over-fusionview"
              >Disclaimer über Fusion-View</label>
            </div>

            <!-- Systemsprache -->
            <div class="display-option-toggle">
              <label
                class="form-label fw-semibold mb-0"
                for="miroTemplateLangSelect"
                i18n="@@fusionconfig-systemlang"
              >Systemsprache</label>
              <p-select
                id="miroTemplateLangSelect"
                [options]="this.systemLanguageOptions"
                optionLabel="label"
                optionValue="value"
                [(ngModel)]="this.fusionService.selectedMiroByTemplate.metadata.botlang"
                (ngModelChange)="this.fusionService.updateFusionField('botlang', this.fusionService.selectedMiroByTemplate.metadata.botlang)"
              ></p-select>
            </div>
          </div>
          <!-- Preview Wireframe -->
          <div class="display-preview">
            <div class="display-preview-frame">
              @if (this.fusionService.selectedMiroByTemplate.metadata.viewMode === 'split' || !this.fusionService.selectedMiroByTemplate.metadata.viewMode) {
                <div class="preview-split">
                  <div class="preview-content-area">
                    <div class="preview-content-line"></div>
                    <div class="preview-content-line short"></div>
                    <div class="preview-content-line"></div>
                  </div>
                  @if (!this.fusionService.selectedMiroByTemplate.metadata.botHidden) {
                    <div
                      class="preview-bot-area"
                      >
                      <div class="preview-bot-header"></div>
                      <div class="preview-bot-messages">
                        <div class="preview-bot-bubble"></div>
                        <div class="preview-bot-bubble user"></div>
                      </div>
                      <div class="preview-bot-input"></div>
                    </div>
                  }
                </div>
              }
              @if (this.fusionService.selectedMiroByTemplate.metadata.viewMode === 'split-reverse') {
                <div class="preview-split-reverse">
                  <div class="preview-content-area">
                    <div class="preview-content-line"></div>
                    <div class="preview-content-line short"></div>
                    <div class="preview-content-line"></div>
                  </div>
                  @if (!this.fusionService.selectedMiroByTemplate.metadata.botHidden) {
                    <div
                      class="preview-bot-area"
                      >
                      <div class="preview-bot-header"></div>
                      <div class="preview-bot-messages">
                        <div class="preview-bot-bubble"></div>
                        <div class="preview-bot-bubble user"></div>
                      </div>
                      <div class="preview-bot-input"></div>
                    </div>
                  }
                </div>
              }
              @if (this.fusionService.selectedMiroByTemplate.metadata.viewMode === 'window') {
                <div class="preview-window">
                  <div class="preview-content-area full">
                    <div class="preview-content-line"></div>
                    <div class="preview-content-line short"></div>
                  </div>
                  @if (!this.fusionService.selectedMiroByTemplate.metadata.botHidden) {
                    <div
                      class="preview-bot-overlay"
                      >
                      <div class="preview-bot-header"></div>
                      <div class="preview-bot-messages">
                        <div class="preview-bot-bubble"></div>
                        <div class="preview-bot-bubble user"></div>
                      </div>
                      <div class="preview-bot-input"></div>
                    </div>
                  }
                </div>
              }
              @if (this.fusionService.selectedMiroByTemplate.metadata.viewMode === 'full') {
                <div class="preview-full">
                  @if (!this.fusionService.selectedMiroByTemplate.metadata.botHidden) {
                    <div
                      class="preview-bot-area fullscreen"
                      >
                      <div class="preview-bot-header"></div>
                      <div class="preview-bot-messages">
                        <div class="preview-bot-bubble"></div>
                        <div class="preview-bot-bubble user"></div>
                        <div class="preview-bot-bubble"></div>
                      </div>
                      <div class="preview-bot-input"></div>
                    </div>
                  }
                  @if (this.fusionService.selectedMiroByTemplate.metadata.botHidden) {
                    <div
                      class="preview-hidden-label"
                      i18n="@@fusionconfig-preview-hidden"
                    >Bot ausgeblendet</div>
                  }
                </div>
              }
              @if (this.fusionService.selectedMiroByTemplate.metadata.viewMode === 'float') {
                <div class="preview-float">
                  <div class="preview-content-area full">
                    <div class="preview-content-line"></div>
                    <div class="preview-content-line short"></div>
                    <div class="preview-content-line"></div>
                  </div>
                  @if (!this.fusionService.selectedMiroByTemplate.metadata.botHidden) {
                    <div
                      class="preview-bot-float"
                      >
                      <div class="preview-bot-header"></div>
                      <div class="preview-bot-messages">
                        <div class="preview-bot-bubble"></div>
                        <div class="preview-bot-bubble user"></div>
                      </div>
                      <div class="preview-bot-input"></div>
                    </div>
                  }
                </div>
              }
              @if (this.fusionService.selectedMiroByTemplate.metadata.botHidden && this.fusionService.selectedMiroByTemplate.metadata.viewMode !== 'full') {
                <div
                  class="preview-hidden-overlay"
                  >
                  <div class="preview-content-line"></div>
                  <div class="preview-content-line short"></div>
                  <div class="preview-content-line"></div>
                </div>
              }
              @if (!this.fusionService.selectedMiroByTemplate.metadata.botButtonHidden) {
                <div
                  class="preview-bot-fab"
                  >
                  <i class="ri-chat-3-line"></i>
                </div>
              }
            </div>
          </div>
        </div>
      </section>
      <hr class="fusion-divider" />
      <!-- ===== 3. LOGIK-EDITOR ===== -->
      <section class="fusion-section">
        <h6
          class="fusion-section-title"
          i18n="@@fusion-logic-editor-heading"
        >Logik-Editor</h6>
        <p
          class="fusion-section-hint"
          i18n="@@fusion-logic-editor-description"
          >
          Im Logik-Editor kannst du Abläufe und Regeln für diesen Fusion-View per Scripting anpassen.
        </p>
        <p-button
          [outlined]="true"
          severity="primary"
          size="small"
          icon="ri-code-box-line"
          [gotoBlockly]="this.editorItemsService.getEditorItemByUniqueId('fusion_'+this.fusionService.selectedMiroByTemplate._id)"
          i18n-label="@@to-scripting"
          label="Zum Scripting"
        ></p-button>
      </section>
    </div>
  </div>
}

@if (this.fusionService.selectedMiroByTemplate && !this.fusionService.selectedMiroByTemplate.metadata.templateId) {
  <div class="fusion-container">
    <div class="video-empty">
      <div class="video-empty-icon">
        <i class="ri-artboard-2-line"></i>
      </div>
      <h5
        class="mb-1"
        i18n="@@embed-miro-template"
      >Miro-Template einbinden</h5>
      <small
        class="text-muted mb-3 d-block text-center"
        i18n="@@embed-miro-template-description"
        >
        Füge eine Miro-Template-URL ein, um das Board mit diesem Fusion-View zu verbinden.
      </small>
      <div class="video-empty-input">
        <input
          pInputText
          #emptyUrlInput
          type="text"
          class="flex-fill"
          placeholder="https://miro.com/app/board/..."
          />
        <p-button
          size="small"
          severity="primary"
          (onClick)="this.boardUrlInputChange(emptyUrlInput.value)"
          i18n-label="@@use"
          label="Verwenden"
        ></p-button>
      </div>
    </div>
  </div>
}
